import { useAuth } from './contexts/authContext'; // Adjust the import path according to your project structure
import { useNavigate } from 'react-router-dom';

const apiBaseURL = '/api'; // Adjust your API base URL here

// Custom hook for API calls
export const useApi = () => {
    const { user } = useAuth(); // Get the token from AuthContext
    const navigate = useNavigate();  

    const get = async (endpoint) => {
        const headers = {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${user.token}`, // Include the Bearer token if it exists
        };

        try {
            const response = await fetch(`${apiBaseURL}${endpoint}`, {
                method: 'GET',
                headers,
            });

            if (!response.ok) {
                if (response.status === 401 || response.status === 403) {
                    navigate('/login')
                    return
                } else {
                    const error = await response.json();
                    throw new Error(error.message || 'Something went wrong');
                }
            }

            return await response.json(); // Parse and return JSON response
        } catch (error) {
            console.error('GET request error:', error);
            throw error; // Rethrow error for handling in the component
        }
    };

    const post = async (endpoint, body) => {
        const headers = {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${user.token}`, // Include the Bearer token if it exists
        };

        try {
            const response = await fetch(`${apiBaseURL}${endpoint}`, {
                method: 'POST',
                headers,
                body: JSON.stringify(body),
            });

            if (!response.ok) {
                if (response.status === 401) {
                    navigate('/login')
                    return
                } else {
                    const error = await response.json();
                    throw new Error(error.message || 'Something went wrong');
                }
            }

            return await response.json(); // Parse and return JSON response
        } catch (error) {
            console.error('POST request error:', error);
            throw error; // Rethrow error for handling in the component
        }
    };

    // Return the API methods
    return {
        get,
        post,
    };
};